/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { selectLanguage } from "../../redux/language/selector";
import { useSelector } from "react-redux";
import PricingPortal from "./../../pages/PricingPortal";
import PricingApi from "./../../pages/PricingApi";
import Footer from "./../global/Footer";
import NavbarBottom from "./../global/NavbarBottom";
import { useTranslation } from "react-i18next";

/* ─── Quantera scoped styles ─── */
const quanteraStyles = `
  .q-vars {
    --navy:      #1A2E6B;
    --navy-dk:   #0F1D4A;
    --gold:      #F5A623;
    --teal:      #0891B2;
    --green:     #16A34A;
    --gray-50:   #F4F6FB;
    --gray-100:  #E8ECF4;
    --gray-200:  #CDD5E0;
    --gray-500:  #6B7A99;
    --gray-700:  #374151;
    --gray-900:  #111827;
    --orange:    #F59E0B;
    --orange-dk: #D97706;
    --radius:    12px;
    --shadow:    0 2px 16px rgba(0,0,0,0.09);
  }
  .quantera-section { background: #F1F5F9; padding: 40px 20px; }
  .q-section-title {
    text-align: center;
    font-size: 28px;
    font-weight: 800;
    color: #1A2E6B;
    margin-bottom: 6px;
    letter-spacing: 0.03em;
  }
  .q-section-sub {
    text-align: center;
    font-size: 16px;
    color: #6B7A99;
    margin-bottom: 28px;
  }
  .quantera-wrap { max-width: 1040px; margin: 0 auto; }
 
  .q-card {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 16px rgba(0,0,0,0.09);
    overflow: hidden;
    margin-bottom: 16px;
  }
  .q-header {
    display: flex; align-items: center; gap: 12px;
    padding: 13px 20px; font-size: 0.87rem; font-weight: 700;
    text-transform: uppercase; letter-spacing: 0.03em;
    color: #fff; cursor: pointer; user-select: none;
    border: none; width: 100%; text-align: left;
  }
  .q-header:hover { filter: brightness(1.07); }
  .q-badge {
    display: inline-flex; align-items: center; justify-content: center;
    width: 30px; height: 30px; border-radius: 50%;
    background: rgba(255,255,255,0.22); font-size: 14px; font-weight: 800; flex-shrink: 0;
  }
  .q-label { flex: 1; font-size: 16px; font-weight: 700; letter-spacing: 0.03em; }
  .q-chevron {
    display: inline-flex; align-items: center; justify-content: center;
    width: 26px; height: 26px; border-radius: 50%;
    background: rgba(255,255,255,0.15); flex-shrink: 0;
    transition: transform 0.25s ease;
  }
  .q-chevron.collapsed { transform: rotate(-90deg); }
 
  .h-orange { background: linear-gradient(90deg,#F59E0B,#D97706); }
  .h-teal   { background: linear-gradient(90deg,#0891B2,#0369A1); }
  .h-green  { background: linear-gradient(90deg,#059669,#047857); }
  .h-navy   { background: linear-gradient(90deg,#1E3A5F,#1e40af); }
 
  .q-body { padding: 20px; }
 
  .q-note-italic {
    font-style: italic; font-size: 14px; color: #6B7280;
    margin-bottom: 14px; padding: 8px 12px;
    background: #F4F6FB; border-left: 3px solid #F59E0B; border-radius: 4px;
  }
 
  .q-table { width: 100%; border-collapse: collapse; font-size: 14px; }
  .q-table thead th {
    background: #F4F6FB; color: #111827; font-weight: 700; font-size: 14px;
    padding: 9px 12px; text-align: left; border-bottom: 2px solid #CDD5E0;
  }
  .q-table thead th:last-child { text-align: center; }
  .q-table tbody tr:nth-child(even) { background: #F4F6FB; }
  .q-table tbody tr:hover { background: #EFF6FF; }
  .q-table tbody td { padding: 8px 12px; border-bottom: 1px solid #CDD5E0; font-size:14px; white-space: nowrap; }
  .q-table tbody td:last-child { text-align: center; font-weight: 700; color: #1A2E6B; }
  .q-free-val { color: #16A34A !important; font-weight: 700; }
 
  .tier-table thead th { text-align: center; }
  .tier-table thead th:first-child { text-align: left; }
  .tier-table tbody td:last-child { text-align: center; font-size: 14px; }
  .tier-hdr {
    font-size: 0.76rem; font-weight: 700; text-align: center; color: #fff;
    padding: 6px 10px; letter-spacing: 0.03em;
  }
  .tier-hdr.orange { background: #F59E0B; }
  .tier-hdr.teal   { background: #0891B2; }
 
  .q-two-col { display: grid; grid-template-columns: 1fr 1fr; gap: 20px; }
  @media (max-width: 680px) { .q-two-col { grid-template-columns: 1fr; } }
 
  .q-sub-title {
    font-size: 14px; font-weight: 700; text-transform: uppercase;
    letter-spacing: 0.05em; color: #1A2E6B;
    margin-bottom: 10px; padding-bottom: 5px; border-bottom: 2px solid #CDD5E0;
  }
  .q-sub-title.orange { color: #D97706; border-color: #F59E0B; }
  .q-sub-title.teal   { color: #0891B2; border-color: #0891B2; }
 
  .q-f-list { list-style: none; padding: 0; margin: 0; }
  .q-f-list li {
    display: flex; gap: 8px; align-items: flex-start;
    padding: 5px 0; border-bottom: 1px dashed #CDD5E0;
  }
  .q-f-list li:last-child { border: none; }
  .q-f-list li::before {
    content: '✓'; color: #16A34A; font-weight: 700;
    flex-shrink: 0; font-size: 12px; margin-top: 1px;
  }
  .q-f-list li > span { font-size: 14px; color: #374151; }
 
  .q-b-list { list-style: none; padding: 0; margin: 0; }
  .q-b-list li {
    display: flex; gap: 8px; align-items: flex-start;
    padding: 5px 0; border-bottom: 1px dashed #CDD5E0;
  }
  .q-b-list li:last-child { border: none; }
  .q-b-list li::before {
    content: '●'; font-size: 12px; color: #F59E0B;
    flex-shrink: 0; margin-top: 7px;
  }
  .q-b-list li > span { font-size: 14px; color: #374151; line-height: 1.6; }
 
  .q-info-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; margin-bottom: 14px; }
  .q-info-box {
    background: #F4F6FB; border: 1px solid #CDD5E0;
    border-radius: 8px; padding: 10px 12px;
  }
  .q-info-box .ib-label {
    display: block; font-size: 14px; font-weight: 700; color: #6B7280;
    text-transform: uppercase; letter-spacing: 0.04em; margin-bottom: 4px;
  }
  .q-info-box .ib-val {
    display: block; font-size: 14px; font-weight: 700; color: #1A2E6B; line-height: 1.3;
  }
  .q-info-box .ib-note {
    display: block; font-size: 14px; color: #9CA3AF; margin-top: 2px;
  }
 
  .q-contact-box {
    background: linear-gradient(135deg,#EEF2FF,#E0F2FE);
    border: 1px solid #BFDBFE; border-radius: 8px; padding: 16px;
  }
  .q-contact-box h3 { font-size: 14px; font-weight: 700; color: #1A2E6B; margin-bottom: 6px; }
  .q-contact-box p { font-size: 14px; color: #4B5563; margin-bottom: 14px; line-height: 1.55; }
  .q-contact-items { display: flex; gap: 20px; flex-wrap: wrap; }
  .q-contact-item { display: flex; align-items: center; gap: 10px; }
  .q-contact-item .ic {
    width: 32px; height: 32px; background: #1A2E6B; color: #fff;
    border-radius: 50%; display: flex; align-items: center; justify-content: center;
    font-size: 14px; flex-shrink: 0;
  }
  .q-contact-item .ic-text small { display: block; font-size: 14px; color: #6B7280; }
  .q-contact-item .ic-text strong { font-size: 14px; color: #1A2E6B; }
 
  .q-divider { height: 1px; background: #CDD5E0; margin: 16px 0; }
  .q-sub-block { margin-bottom: 18px; }
`;
 
/* ─── Collapsible Card ─── */
const QCard = ({ id, badgeLabel, headerText, headerClass, children }) => {
  const [collapsed, setCollapsed] = useState(false);
  return (
    <div className="q-card">
      <button
        className={`q-header ${headerClass}`}
        onClick={() => setCollapsed((c) => !c)}
      >
        <span className="q-badge">{badgeLabel}</span>
        <span className="q-label">{headerText}</span>
        <span className={`q-chevron${collapsed ? " collapsed" : ""}`}>
          <svg viewBox="0 0 24 24" width="14" height="14" fill="none"
            stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="6 9 12 15 18 9" />
          </svg>
        </span>
      </button>
      {!collapsed && <div className="q-body">{children}</div>}
    </div>
  );
};
 


const PricingContent = (props) => {
  const { t, i18n } = useTranslation();

  const language = useSelector(selectLanguage);

  useEffect(() => {
    document.title = t("pricing-page.title_label");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [language]);

  // useEffect(() => {
  //   document.getElementById("li-api").classList.remove("active");
  //   document.getElementById("li-portal").classList.remove("active");

  //   if (props.id === "portal") {
  //     document.getElementById("li-portal").classList.add("active");
  //     document.getElementById("portal").classList.add("active", "in");
  //   } else if (props.id === "api") {
  //     document.getElementById("li-api").classList.add("active");
  //     document.getElementById("api").classList.add("active", "in");
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [props.id]);

  /* ─── Quantera Table Section ─── */
const QuanteraTable = () => (
  <div className="q-vars quantera-section">
    <style>{quanteraStyles}</style>
 
    <div className="q-section-title">
            {t("pricing.title")}
    </div>
    <div className="q-section-sub">
         {t("pricing.section")}
    </div>
 
    <div className="quantera-wrap">
 
      {/* PHẦN 1 */}
      <QCard
        id="q1"
        badgeLabel="1"
        headerText=         {t("pricing.part1.header")}
        headerClass="h-orange"
      >
        <div className="q-note-italic">
            {t("pricing.part1.note")}
        </div>
        <table className="q-table">
          <thead>
            <tr>
              <th>  {t("pricing.part1.table_col1")}</th>
              <th> {t("pricing.part1.table_col2")}</th>
              <th> {t("pricing.part1.table_col3")}</th>
            </tr>
          </thead>
          <tbody>
            <tr><td><strong>{t("pricing.part1.rows.0.service")}</strong></td><td>{t("pricing.part1.row_free")}</td><td className="q-free-val">0</td></tr>
            <tr><td><strong>{t("pricing.part1.rows.1.service")}</strong></td><td>{t("pricing.part1.row_deducted")}</td><td>3.500</td></tr>
            <tr><td><strong>{t("pricing.part1.rows.2.service")}</strong></td><td>{t("pricing.part1.row_deducted")}</td><td>1.500</td></tr>
            <tr><td><strong>{t("pricing.part1.rows.3.service")}</strong></td><td>{t("pricing.part1.row_deducted")}</td><td>2.500</td></tr>
            <tr><td><strong>{t("pricing.part1.rows.9.service")}</strong></td><td>{t("pricing.part1.row_deducted")}</td><td>3.000</td></tr>
            <tr><td><strong>{t("pricing.part1.rows.4.service")}</strong></td><td>{t("pricing.part1.row_deducted")}</td><td>300</td></tr>
            <tr><td><strong>{t("pricing.part1.rows.5.service")}</strong></td><td>{t("pricing.part1.row_deducted")}</td><td>1.400</td></tr>
            <tr><td><strong>{t("pricing.part1.rows.6.service")}</strong></td><td>{t("pricing.part1.row_deducted")}</td><td>3.500</td></tr>
            <tr><td><strong>{t("pricing.part1.rows.7.service")}</strong></td><td>{t("pricing.part1.row_deducted")}</td><td>1.000</td></tr>
            <tr><td><strong>{t("pricing.part1.rows.8.service")}</strong></td><td>{t("pricing.part1.row_deducted")}</td><td>1.000</td></tr>
          </tbody>
        </table>
      </QCard>
 
      {/* PHẦN 2 */}
      <QCard
        id="q2"
        badgeLabel="2"
        headerText={t("pricing.part2.header")}
        headerClass="h-teal"
      >
        <div className="q-two-col">
          <div>
            <div className="q-sub-block">
              <div className="q-sub-title teal">{t("pricing.part2.section_a_title")}</div>
              <ul className="q-f-list">
                <li><span>{t("pricing.part2.section_a_items.0")}</span></li>
                <li><span>{t("pricing.part2.section_a_items.1")}</span></li>
                <li><span>{t("pricing.part2.section_a_items.2")}<strong>{t("pricing.part2.section_a_items.3")}</strong></span></li>
              </ul>
            </div>
            <div className="q-divider" />
            <div className="q-sub-block">
              <div className="q-sub-title teal">{t("pricing.part2.section_b_title")}</div>
              <ul className="q-b-list">
                <li><span>{t("pricing.part2.section_b_items.0")}<strong>{t("pricing.part2.section_b_items.1")}</strong></span></li>
                <li><span>{t("pricing.part2.section_b_items.2")}<strong>{t("pricing.part2.section_b_items.3")}</strong>. {t("pricing.part2.section_b_items.4")}</span></li>
                <li><span>{t("pricing.part2.section_b_items.5")}</span></li>
                <li><span>{t("pricing.part2.section_b_items.6")}<strong>{t("pricing.part2.section_b_items.7")}</strong>.</span></li>
              </ul>
            </div>
          </div>
          <div>
            <div className="q-sub-title orange" style={{ marginBottom: 10 }}>
              {t("pricing.part2.tier_title")}
              <small style={{ display: "block", textTransform: "none", fontWeight: 400, fontSize: "14px", marginTop: 2 }}>
              {t("pricing.part2.tier_subtitle")}
              </small>
            </div>
            <table className="q-table tier-table">
              <thead>
                <tr><th className="tier-hdr orange" colSpan="2" style={{color:"white"}}>{t("pricing.part2.tier_col_header")}</th></tr>
                <tr><th>{t("pricing.part2.tier_col1")}</th><th>{t("pricing.part2.tier_col2")}</th></tr>
              </thead>
              <tbody>
                <tr><td>{t("pricing.part2.tier_rows.0.bracket")}</td><td>{t("pricing.part2.tier_rows.0.price")}</td></tr>
                <tr><td>{t("pricing.part2.tier_rows.1.bracket")}</td><td>{t("pricing.part2.tier_rows.1.price")}</td></tr>
                <tr><td>{t("pricing.part2.tier_rows.2.bracket")}</td><td>{t("pricing.part2.tier_rows.2.price")}</td></tr>
                <tr><td>{t("pricing.part2.tier_rows.3.bracket")}</td><td>{t("pricing.part2.tier_rows.3.price")}</td></tr>
              </tbody>
            </table>
          </div>
        </div>
      </QCard>
 
      {/* PHẦN 3 */}
      <QCard
        id="q3"
        badgeLabel="3"
        headerText={t("pricing.part3.header")}
        headerClass="h-green"
      >
        <div className="q-sub-block">
          <div className="q-sub-title">{t("pricing.part3.benefits_title")}</div>
          <div className="q-two-col">
            <ul className="q-f-list">
              <li><span>{t("pricing.part3.benefits_col1.0")}</span></li>
              <li><span>{t("pricing.part3.benefits_col1.1")}</span></li>
            </ul>
            <ul className="q-f-list">
              <li><span>{t("pricing.part3.benefits_col2.0")}</span></li>
              <li><span>{t("pricing.part3.benefits_col2.1")}</span></li>
            </ul>
          </div>
        </div>
        <div className="q-divider" />
        <div className="q-two-col">
          <div>
            <div className="q-sub-title orange" style={{ marginBottom: 12 }}>
             {t("pricing.part3.api_title")}
            </div>
            <div className="q-info-grid">
              <div className="q-info-box">
                <span className="ib-label">{t("pricing.part3.info_boxes.api_fee_label")}</span>
                <span className="ib-val">{t("pricing.part3.info_boxes.api_fee_val")}</span>
                <span className="ib-note">{t("pricing.part3.info_boxes.api_fee_note")}</span>
              </div>
              <div className="q-info-box">
                <span className="ib-label">{t("pricing.part3.info_boxes.systems_label")}</span>
                <span className="ib-val">{t("pricing.part3.info_boxes.systems_val")}</span>
              </div>
              <div className="q-info-box">
                <span className="ib-label">{t("pricing.part3.info_boxes.support_label")}</span>
                <span className="ib-val">{t("pricing.part3.info_boxes.support_val")}</span>
              </div>
              <div className="q-info-box">
                <span className="ib-label">{t("pricing.part3.info_boxes.commit_label")}</span>
                <span className="ib-val">{t("pricing.part3.info_boxes.commit_val")}</span>
                <span className="ib-note">{t("pricing.part3.info_boxes.commit_note")}</span>
              </div>
            </div>
            <table className="q-table tier-table">
              <thead>
                <tr><th className="tier-hdr teal" colSpan="2" style={{color:"white"}}>{t("pricing.part3.tier_col_header")}</th></tr>
                <tr><th>{t("pricing.part3.tier_col1")}</th><th>{t("pricing.part3.tier_col2")}</th></tr>
              </thead>
              <tbody>
                <tr><td>{t("pricing.part3.tier_rows.0.bracket")}</td><td>{t("pricing.part3.tier_rows.0.price")}</td></tr>
                <tr><td>{t("pricing.part3.tier_rows.1.bracket")}</td><td>{t("pricing.part3.tier_rows.1.price")}</td></tr>
                <tr><td>{t("pricing.part3.tier_rows.2.bracket")}</td><td>{t("pricing.part3.tier_rows.2.price")}</td></tr>
                <tr><td>{t("pricing.part3.tier_rows.3.bracket")}</td><td>{t("pricing.part3.tier_rows.3.price")}</td></tr>
              </tbody>
            </table>
          </div>
          <div>
            <div className="q-sub-title teal" style={{ marginBottom: 12 }}>
              {t("pricing.part3.wallet_title")}
            </div>
            <ul className="q-b-list">
              <li><span><strong>{t("pricing.part3.wallet_items.0")}</strong>{t("pricing.part3.wallet_items.1")}</span></li>
              <li><span><strong>{t("pricing.part3.wallet_items.2")}</strong>{t("pricing.part3.wallet_items.3")}</span></li>
              <li><span><strong>{t("pricing.part3.wallet_items.4")}</strong>{t("pricing.part3.wallet_items.5")}</span></li>
              <li><span><strong>{t("pricing.part3.wallet_items.6")}</strong>{t("pricing.part3.wallet_items.7")}</span></li>
              <li><span>{t("pricing.part3.wallet_items.8")}<strong>{t("pricing.part3.wallet_items.9")}</strong>.</span></li>
            </ul>
          </div>
        </div>
      </QCard>
 
      {/* PHẦN 4 */}
      <QCard
        id="q4"
        badgeLabel="4"
        headerText={t("pricing.part4.header")}
        headerClass="h-navy"
      >
        <div className="q-two-col">
          <div>
            <div className="q-sub-title" style={{ marginBottom: 12 }}>
              {t("pricing.part4.benefits_title")}
            </div>
            <ul className="q-f-list">
              <li><span>{t("pricing.part4.benefits_items.0")}<strong>{t("pricing.part4.benefits_items.1")}</strong>{t("pricing.part4.benefits_items.2")}</span></li>
              <li><span>{t("pricing.part4.benefits_items.3")}<strong>{t("pricing.part4.benefits_items.4")}</strong>.</span></li>
              <li><span>{t("pricing.part4.benefits_items.5")}<strong>{t("pricing.part4.benefits_items.6")}</strong>.</span></li>
            </ul>
          </div>
          <div className="q-contact-box">
            <h3>{t("pricing.part4.contact_title")}</h3>
            <p>{t("pricing.part4.contact_desc")}</p>
            <div className="q-contact-items">
              <div className="q-contact-item">
                <div className="ic">📞</div>
                <div className="ic-text">
                  <small>{t("pricing.part4.contact_hotline_label")}</small>
                  <strong>1900 6884</strong>
                </div>
              </div>
              <div className="q-contact-item">
                <div className="ic">✉</div>
                <div className="ic-text">
                  <small>{t("pricing.part4.contact_email_label")}</small>
                  <strong>info@quantera.vn</strong>
                </div>
              </div>
            </div>
          </div>
        </div>
      </QCard>
 
    </div>{/* /quantera-wrap */}
  </div>
);

  return (
    <div
      id="content"
      className="fs-navigation-overlay-content fs-navigation-overlay-left-content fs-navigation__0 no-transform overflow-hidden"
    >
      <div className="container-fuild background-pricing-image">
        <div className="container">
          <div className="row">
            <div className="col-sm-12 text-center pt-50 pb-28">
              <h2 className="font-weight-bold mx-auto font-60 text-yellow">
                {t("pricing-page.title")}
              </h2>
              <p className="mt-25 mb-25 text-white">
                {t("pricing-page.sub-title")}
              </p>
            </div>
          </div>
        </div>
      </div>
            {/* ── QUANTERA TABLE ── */}
      <QuanteraTable />
      {/* <nav className="pricing-navigation">
        <div className="container">
          <div className="row">
            <div className="col-xs-12 col-sm-12">
              <ul className="list-infrastructure list list-unstyled tabs-flex" style={{ display: "flex", width: "100%", margin: 0, padding: 0, listStyle: "none" }}>
                <li id="li-portal" style={{ flex: 1, display: "flex" }}>
                  <NavLink to="/pricing/portal" style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", width: "100%", textAlign: "center" }}>
                    <span className="font-18">
                      {t("pricing-page.portal-pricing.title")}
                    </span>
                    <div className="tab-line"></div>
                  </NavLink>
                </li>
                <li id="li-api" style={{ flex: 1, display: "flex" }}>
                  <NavLink to="/pricing/api" style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", width: "100%", textAlign: "center" }}>
                    <span className="font-18">
                      {t("pricing-page.api-pricing.title")}
                    </span>
                    <div className="tab-line"></div>
                  </NavLink>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </nav> */}

      {/* <div className="tab-content mt-0">
        <PricingPortal following={props.id === "portal" ? true : false} />
        <PricingApi following={props.id === "api" ? true : false} />
      </div> */}
      
      
      <div className="border-bottom bg-color p-0" style={{backgroundColor:"#ffffff"}}>
        <div className="container">
          <div className="row isign-apis">
            <div className="col-md-5 pl-md-0">
              <h2 className="text-get-started">
                {t("home-page.home-footer.footer-1")}
              </h2>
              <h4 className="text-p">
                {t("home-page.home-footer.footer-2")}{" "}
                <a
                  href={`https://gopaperless.mobile-id.vn/workflow/portal/login?language=${
                    i18n.language || "vi"
                  }`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="underline"
                >
                  {t("home-page.home-footer.footer-3")}{" "}
                </a>
              </h4>
            </div>
            <div className="col-sm-12 col-md-7">
              <div className="btn-box">
                <a
                  href={`https://gopaperless.mobile-id.vn/workflow/portal/login?language=${
                    i18n.language || "vi"
                  }`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-secondary"
                >
                  {t("home-page.home-footer.button-signing")}{" "}
                </a>
                <Link to="/digital-signature" target="_blank" rel="noopener noreferrer" className="btn-primary ">
                  {t("home-page.home-footer.button-why-paperless")}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
      <NavbarBottom />
    </div>
  );
};

export default PricingContent;